module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isInitial && _vm.isOptOutBdc && _vm.isNot1Click && _vm.isOptOutChoice) ? _c('div', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.triggerModal
    }
  }, [_vm._v(_vm._s(_vm.$t('cancelOneClick.changeOffer')))])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-81c3e8fe","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/common/components/modal-cancel-one-click.vue
// module id = 864
// module chunks = 0 1